import ShiftsComponent from "../components/Shifts";
import useShiftsList from "../hooks/useShiftsList";

function Shifts(props) {
  const useShiftsListProps = useShiftsList(props);
  return <ShiftsComponent {...useShiftsListProps} />;
}

export default Shifts;
